export const DELIVERY_OPTIONS = [{ name: 'deliverDoor' }, { name: 'waitOutside' }, { name: 'leaveInDoor' }];
export const INSTRUCTIONS = 'instructions';
export const DELIVERY_OPTIONS_RADIO_NAME = 'deliveryOption';
